import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { GetOrdersStatusApiParameter } from "@WhiteCap/Handlers/OrderHistory/LoadOrdersStatus";

export interface OrderDeliveryStatus {
    uri: any
    erpOrders: ErpOrder[]
    properties: Properties
  }
  
  export interface ErpOrder {
    oderId: string;
    erpOrderNumber: string;
    shipViaDescription: string;
    status: string[];
    trackingURLs: any[];
    orderLinesCount: number;
    noOfShipmentPackages: number;
    isMultipleShipment: boolean;
  }
  
  export interface Properties {}
  const orderStatusUrl = "/api/v1/realtimeorderstatus/getrealtimeorderstatus";

  export function getOrderStatus(orderNumber: string[]){
    const queryParams = orderNumber.map(id => `orderNumber=${id}`).join('&');
    return get<OrderDeliveryStatus>(`${orderStatusUrl}?${queryParams}`);
   // return get<OrderDeliveryStatus>(`/api/v1/realtimeorderstatus/getrealtimeorderstatus?orderNumber=3C9D79F8-9B2B-45B3-B808-B0CA01790239&orderNumber=A7D0F6AD-57C5-4AD7-8DC3-B0CE01494FA6&orderNumber=37183BE9-C51F-464B-863B-B0CA01694FE4&orderNumber=37183BE9-C51F-464B-863B-B0CA01694FE4&orderNumber=5A0D3FFA-9763-433D-AD47-B0CA016B6D02&orderNumber=44F9E842-BEC4-41F6-95F3-B0CA01757867`);

}